import React from 'react';
import { TextPlayer } from '../../components';
import styles from "./ContentWithTextPlayer.module.css";
import { useAppSelector } from '../../hooks';

interface ContentWithTextPlayerProps {
    contentHTML: string;
}

const cssStyle = `
#htmlBox font {
    color: #333333;
}
#htmlBox .jk-en {
    font-size: 20px;
    margin-block-start: 0 !important;
    margin-block-end: 0 !important;
}
#htmlBox .jk-zh {
    margin-block-start: 0 !important;
    margin-block-end: 0 !important;
    font-size: 20px !important;
}
#htmlBox li.jk-zh {
    list-style-type: none;
}
#htmlBox img {
    max-width: 100%;
    height: auto;
}
#htmlBox .clickable:hover {
  cursor: pointer;
}
#htmlBox code {
  font-family: inherit;
  font-size: inherit;
}
#htmlBox a {
    pointer-events: none;
    cursor: default;
    color: inherit;
}
/* 隐藏40001-GoF Design Patterns的代码实现部分 */
#htmlBox div.section.implementations {
    display: none;
}
/* 隐藏Swift的超链接图片 */
#htmlBox svg.svg-icon.link-icon.icon {
    display: none;
}
/* 隐藏Tailwind CSS的图片 */
#htmlBox div.hidden > img {
    display: none;
}
#htmlBox span.flex > svg {
    display: none;
}
#htmlBox a > svg {
    display: none;
}
#htmlBox .svg-icon {
    display: none;
}
#htmlBox button.text-slate-500[type="button"] {
    display: none;
}
#htmlBox button.btn-clipboard {
    display: none;
}
`;

export const ContentWithTextPlayer: React.FC<ContentWithTextPlayerProps> = React.memo(({ contentHTML }) => {

    const { isMember } = useAppSelector((state) => state.user);
    
    const memberSpecificStyle = isMember ? '' : `
    #htmlBox .jk-zh {
        display: none;
    }
    #htmlBox .jk-en {
        position: relative;
    }
    #htmlBox .jk-en::after {
        content: "开通会员显示译文";
        display: block;
        font-size: 14px;
        margin-top: 4px;
        background-color: #f5f5f5;
        padding: 4px 8px;
        border-radius: 4px;
    }
    `;
    
    return (
        <div className={styles.container}>
            <div 
                id='htmlBox'
                className={styles.htmlBox}
                translate="no"
                dangerouslySetInnerHTML={{
                    __html: `<style>${cssStyle}${memberSpecificStyle}</style>${contentHTML}`,
                }}
            />
            <TextPlayer />
        </div>
    );
}, (prevProps, nextProps) => prevProps.contentHTML === nextProps.contentHTML);
